import type { PropsWithChildren } from 'react';
import type { Slide } from '@core-api/presentation/types/response';
import { FullSizeBackgroundDataHandler } from '@mentimeter/slides-presentation/layout/full-size-background';
import { PartialImageLayoutDataHandler } from '@mentimeter/slides-presentation/layout/partial-image-layout';
import { useQuestion } from '../data-mediation';

export const SfinxSlideImageLayoutDataHandler = ({
  children,
}: PropsWithChildren) => {
  const question = useQuestion();
  const slide = question as Slide;

  const image = {
    url: slide.images?.[0]?.presets.original.url,
    altText: slide.images[0]?.altText,
  };
  const staticContent = slide.staticContent;
  const hasInteractiveContents = slide.interactiveContents?.length > 0;

  return (
    <FullSizeBackgroundDataHandler image={image} staticContent={staticContent}>
      <PartialImageLayoutDataHandler
        image={image}
        staticContent={staticContent}
        hasInteractiveContents={hasInteractiveContents}
      >
        {children}
      </PartialImageLayoutDataHandler>
    </FullSizeBackgroundDataHandler>
  );
};
